import { createContext, useContext, useEffect, useState } from "react";
import { opsMe, opsLogin, opsLogout } from "./opsApi";

const Ctx = createContext(null);

export function OpsAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, obj=auth, false=anon
  useEffect(() => {
    opsMe().then(setUser).catch(() => setUser(false));
  }, []);
  const login = async (email, password) => {
    const d = await opsLogin(email, password);
    setUser(d.user);
    return d.user;
  };
  const logout = async () => {
    try { await opsLogout(); } catch (e) { /* ignore */ }
    setUser(false);
  };
  return <Ctx.Provider value={{ user, setUser, login, logout }}>{children}</Ctx.Provider>;
}

export const useOpsAuth = () => useContext(Ctx);
